var levenshtein = require('fast-levenshtein');
var removeDiacritics = require('diacritics').remove;

export default function getClosestFilter(input, filters){
    console.log(filters);
    console.log(input);
    if(Array.isArray(filters) && input && input.length > 0){
        let foundMatch = filters.filter(f=>{
            if(f.name && f.name.length > 0){
                let n_input = cleanSpecialChar(input);
                let n_filter = f.name;
                if(n_filter.indexOf("-") !== -1){
                    let in_filter = n_filter.split("-");
                    for (let index = 0; index < in_filter.length; index++) {
                        const element = in_filter[index];
                        let n_element = cleanSpecialChar(element);
                        let distance = levenshtein.get(n_input, n_element);
                        if(distance === 0){
                            return true;
                        }

                    }
                }
                //test for some specifics cases (Chalon-sur-saone for example)
                n_filter = cleanSpecialChar(f.name);
                let distance = levenshtein.get(n_input, n_filter);
                if(distance === 0){
                    return true;
                }
                
            }
            return false;
        });

        if(foundMatch && foundMatch.length > 0){
            return foundMatch[0];
        }
    }
    return '';
};

function cleanSpecialChar(str){
    return removeDiacritics(str).replace(/[&\/\\#,+()$~%.'":*?<>{}-\s]/g,'').toLowerCase().trim();
}